import React, { useState } from 'react'
import { Button, Col, Divider, Popconfirm, Row, Table } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import WrappedBrandMaterialForm from './BrandMaterialForm'
import { useDispatch, useSelector } from 'react-redux'
import { deleteBrandMaterial, saveBrandMaterial ,fetchBrandById } from '../../../modules/brand'
import { useDeepEffect } from '../../../utils/hooks'

const BrandMaterial = ({ brand, onCancel }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)

  const { brandObj,isLoading ,materials} = useSelector(
    (state) => ({
      brandObj: state.brand.brandObj,
      isLoading: state.brand.isLoading,
      materials: state.material.materials
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandById(brand.id))
  }

  useDeepEffect(() => {
    if (brand) {
      fetchData()
    }
  }, [brand])

  const columns = [
    {
      title: 'รูป',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => <img src={text} alt="" width={64} height={64} />
    },
    {
      title: 'Material',
      key: 'name',
      dataIndex: 'name'
    },
    {
      title: 'หมวด',
      key: 'category',
      dataIndex: 'category',
      render: (text) => <span>{text.name}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onCloseModal = async () => {
    setVisible(false)
    await dispatch(fetchBrandById(brand.id))
  }

  const onOk = async (materialIds) => {
    const data = {
      brandId: brandObj.id,
      materialIds: materialIds
    }

    await dispatch(saveBrandMaterial(data))
    await setVisible(false)
    await dispatch(fetchBrandById(brand.id))
  }

  const onDelete = async (materialId) => {
    const data = {
      brandId: brandObj.id,
      materialId: materialId
    }
    await dispatch(deleteBrandMaterial(data))
    await dispatch(fetchBrandById(brand.id))
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Material List</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              เพิ่มวัสดุ
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <Table
        title={HeaderTable}
        bordered
        loading={isLoading}
        dataSource={brandObj.materialList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <WrappedBrandMaterialForm
        myMaterials={brandObj.materialList}
        materials={materials}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </div>
  )
}

export default BrandMaterial
